import { slugify } from '#layers/base/public';

export function getSpaceRouteParams(space: { id: string; title: string }) {
	return {
		spaceSlug: slugify(space.title.toLowerCase()),
	};
}

export function getSpacePageRouteParams(page: { id: string; title: string }) {
	return {
		pageSlug: slugify(page.title.toLowerCase()),
	};
}
